// Caltech's undergraduate majors (#2652, founder 2026-09-30: "majors offered
// by the college in the public page"). Read on 2026-10-01 from the official
// Caltech Catalog 2026-2027, Information for Undergraduate Students,
// Graduation Requirements, All Options: every page named "... Option" (with or
// without "and Minor"); minor-only pages (Aerospace, Control and Dynamical
// Systems, Neurobiology, Robotics, Structural Mechanics, Visual Culture) are
// left out. Caltech calls a major an "option"; the catalog's general
// requirements say every option leads to a Bachelor of Science, so each is
// BS. The catalog lists options in one list without divisions, so this is one
// group. Geological and Planetary Sciences keeps the areas the catalog names
// in its title. A soft hyphen in the Chemistry heading is dropped. No
// official admission page read for this file sets an extra requirement for
// an option, so there are no flags. The KB's list was the starting point;
// the catalog wins.
const majors = {
    "slug": "california-institute-of-technology",
    "read": "2026-10-01",
    "intro": "Every undergraduate option (Caltech's word for a major) in Caltech's official 2026-2027 Catalog. Each leads to a Bachelor of Science. Minors are left out.",
    "groups": [
        {
            "name": "Undergraduate options",
            "source": {
                "label": "Caltech Catalog 2026-2027, Graduation Requirements, All Options",
                "url": "https://catalog.caltech.edu/current/information-for-undergraduate-students/graduation-requirements-all-options/"
            },
            "majors": [
                {
                    "name": "Applied and Computational Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business, Economics, and Management",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computation and Neural Systems",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering and Applied Science",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geological and Planetary Sciences",
                    "degree": "BS",
                    "note": "Areas: Geology, Geobiology, Geochemistry, Geophysics, Planetary Science."
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "History and Philosophy of Science",
                    "degree": "BS"
                },
                {
                    "name": "Information and Data Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies Program",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
